// extracted by mini-css-extract-plugin
export default {"error":"YnEMz","error__text":"lwKJt","error__btn":"slA1o"};